import { DynamoNode } from "dynamo-models";
import { ConnectDragSource, ConnectDropTarget } from "react-dnd";
import { AbsComponentFactory } from "..";
import { MetaNode } from "../../supportNodes";
import { EditorMode } from "../..";
import { doSetSelectedNode } from "../../redux";

export interface INodeDropCollectedProps {
    connectDropTarget: ConnectDropTarget;

    canDrop: boolean;

    isOverShallow: boolean;

    isOverDeep: boolean;

    isHoveringLeft: boolean;

    isHoveringRight: boolean;

    selectedNodeId?: string;
}

export interface INodeDragCollectedProps {
    connectDragSource: ConnectDragSource;

    isDragging: boolean;
}

export interface INodePropsInvar extends INodeDropCollectedProps, INodeDragCollectedProps {
    keyIndex: number;

    factory: AbsComponentFactory;

    previewFactory: AbsComponentFactory;

    context: any;

    MetaNode: MetaNode;

    spacing: number;

    hasUnsavedChanges: boolean;
}

export class NodeProps<TNode extends DynamoNode> implements INodePropsInvar {
    constructor(node: TNode, parentNode: DynamoNode, factory: AbsComponentFactory, previewFactory: AbsComponentFactory, context?: any, displayName?: string) {
        this.node = node;
        this.parentNode = parentNode;
        this.factory = factory;
        this.previewFactory = previewFactory;
        this.context = context !== undefined ? context : {};
        this.id = node.nodeId;
        this.displayName = displayName;
    }

    public displayName?: string;

    public node: TNode;

    public parentNode: DynamoNode;

    public keyIndex: number = 0;

    public factory: AbsComponentFactory;

    public previewFactory: AbsComponentFactory;

    public context: any;

    public MetaNode!: MetaNode;

    public connectDropTarget!: ConnectDropTarget;

    public connectDragSource!: ConnectDragSource;

    public canDrop!: boolean;

    public isOverShallow!: boolean;

    public isOverDeep!: boolean;

    public isDragging!: boolean;

    public isHoveringLeft!: boolean;

    public isHoveringRight!: boolean;

    public selectedNodeId?: string;

    public hasUnsavedChanges!: boolean;

    public spacing: number = 10;

    public mode: EditorMode = EditorMode.Edit;

    public onSelect!: (props: NodeProps<DynamoNode>) => () => void;

    public id: string;

    public static CopyFor<TAltNode extends DynamoNode>(origProps: NodeProps<any>, node: TAltNode, keyIndex: number) {
        const copyProps = new NodeProps(node, origProps.node, origProps.factory, origProps.previewFactory, origProps.context);
        copyProps.keyIndex = keyIndex;

        return copyProps;
    }
}
